module.exports = __webpack_public_path__ + "img/exclamation.94a29668.svg";